<template>
  <div class="page-main page-btns">
    <page-title />
    <div class="home-msg">
      <el-row>
        <el-col :span="18">
          <p
            style="font-size:14px;color: rgba(0, 0, 0, 0.65);line-height:1.5em;"
          >My Security Deposit Balance</p>
          <p
            style="font-size:30px;color: #000;line-height:1.5em;font-weight:600;"
          >337,240.00015678 Unit</p>
        </el-col>
        <el-col :span="6" style="text-align:right">
          <el-button @click="handleDeposit(1)">Deposit</el-button>
          <el-button style="background:#1E54E7;color:azure" @click="handleWithdraw(2)">Withdraw</el-button>
        </el-col>
      </el-row>
      <el-row style="margin:20px auto;" class="page_con">
        <p class="fl">
          Expense:
          <span>13, 306.20123678</span>
          Unit
        </p>
        <p class="fl">
          Income:
          <span>13, 306.20123678</span>
          Unit
        </p>
      </el-row>
      <el-card>
        <searchForm :formConfig="formConfig" :source="searchData" @serachHandle="serachHandle" />
        <div>
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="date" label="Date" align="center"></el-table-column>
            <el-table-column prop="name" label="Type" align="center"></el-table-column>
            <el-table-column prop="Data time" label="Event" align="center"></el-table-column>
            <el-table-column prop="UWI" label="Amounts（Unit）" align="center"></el-table-column>
          </el-table>
          <pagination
            :total="total"
            :page.sync="queryParams.page"
            :limit.sync="queryParams.eachpage"
            @pagination="getDataList()"
          />
        </div>
      </el-card>
    </div>

    <el-dialog :title=" type === 1 ? 'Deposit' : 'Withdraw'" :visible.sync="open" width="500px">
      <p class="des">Balance： <span>XXXXX.XX</span>  Unit</p>
      <el-form :model="form" label-position="top" >
        <el-form-item label="Balance" >
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align:center;">
        <el-button @click="open = false">Cancel</el-button>
        <el-button type="primary" @click="open = false">Submit</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import searchForm from '@/components/searchForm/index'
export default {
  components: {
    searchForm,
  },
  data() {
    return {
      searchData: {},
      formConfig: [
        {
          label: 'Date',
          type: 'date',
          prop: 'customerName',
        },
        {
          label: 'Type',
          type: 'select',
          prop: 'type',
          options: [
            {
              text: 'ALL',
              value: 'ALL',
            },
            {
              text: 'Income',
              value: 'Income',
            },
            {
              text: 'Expense',
              value: 'Expense',
            },
          ],
        },
      ],
      tableData: [],
      total: 0,
      queryParams: {
        page: 1,
        eachpage: 10,
      },
      type: 1,
      open: false,
      form:{

      },
    }
  },
  created() {},
  methods: {
    handleClick() {},
    serachHandle(data, cfg) {},
    handleDeposit() {
      this.type = 1
      this.open = true
    },
    handleWithdraw() {
      this.type = 2
      this.open = true
    },
  },
}
</script>
<style scoped lang="scss">
p {
  margin: 0;
}
.page_con {
  p {
    font-size: 22px;
    color: #929dad;
    line-height: 36px;

    span {
      color: rgba(0, 0, 0, 0.85);
    }
  }
  p:first-child {
    background: url('~@/assets/image/expense.png') no-repeat left center;
    background-size: contain;
    padding-left: 45px;
    margin-right: 60px;
  }
  p:last-child {
    background: url('~@/assets/image/income.png') no-repeat left center;
    background-size: contain;
    padding-left: 45px;
  }
}

.des{
  text-align: center;
  font-size: 20px;
 span{
   color: #000;
   font-size: 30px;
 }
}
</style>
